export function getApiEndpoint() {
  if (window.location.hostname === 'demo.chargabull.com') {
    return 'https://api-demo.chargabull.com';
  }
  return process.env.NODE_ENV === 'production' ? 'https://api.chargabull.com' : 'http://localhost';
}
